module.exports = __webpack_public_path__ + "static/media/TATAPOWER_F1.bfba94e7.txt";